import React, { useState } from 'react';
import Modal from '../../shared/modal';
import TeamTable from './TeamTable';
import Button from '../../shared/button';
import NewUserModal from './NewUserModal';
import { useAppDispatch } from '../../app/hooks';
import { tryToFetchTeamMembers, tryToFetchTeamMembersSidebar } from '../../store/brokers/partners/teams/teamsSlice';
import { AdminGuard } from '../../guards/RolesGuard';


interface ITeamsModal {
    openModal: boolean;
    status?: any;
    handleCloseModal: () => void;
    SuccessfullyDeleted: () => void;
}

const TeamsModal = ({
    openModal,
    status,
    handleCloseModal,
    SuccessfullyDeleted
}: ITeamsModal) => {
    const dispatch = useAppDispatch()
    const [newUserModal, setNewUserModal] = useState<boolean>(false)

    const newTeam = async () => {
        try {
            const data = {
                pageSize: 5,
                pageNumber: 1
            };
            await dispatch(tryToFetchTeamMembersSidebar(data)).unwrap()
            await dispatch(tryToFetchTeamMembers({ pageNumber: 1, pageSize: 10 })).unwrap();
        } catch (err) {

        }
    }

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={
                '!rounded-xl max-w-[95%] md:min-w-[70%] lg:min-w-[60%] max-h-[90vh] overflow-y-auto'
            }>
            <div className='p-2 max-w-[95vw] md:min-w-[70%] lg:min-w-[60%]'>
                <p className='mb-2 font-semibold text-sm dark:text-primary-dark'>Team</p>
                {AdminGuard() &&
                    <div className='flex flex-row justify-end my-4'>
                        <Button
                            label={'Add New User'}
                            className='btn-primary-rounded-less'
                            onClickButton={() => setNewUserModal(true)}
                        />
                    </div>
                }
                <div>
                    <TeamTable
                        status={status}
                        onCloseModal={onCloseModal}
                        SuccessfullyDeleted={SuccessfullyDeleted}
                    />
                </div>
                {newUserModal &&
                    <NewUserModal
                        openModal={true}
                        handleCloseModal={() => setNewUserModal(false)}
                        onAddNewSuccessfully={newTeam}
                    />
                }
            </div>
        </Modal >
    )
}
export default TeamsModal;